import { MODERATOR_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Moderator } from 'core/models/Moderator'

const intialState: { moderators: Moderator[], count: number, currentPage: number, isLoading: boolean } = {
  moderators: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    moderators: Moderator[];
    count: number;
    currentPage: number;
  }
}

export default function spaceListReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case MODERATOR_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case MODERATOR_LIST_ACTION.SUCCESS:
      const { moderators, count, currentPage } = action.payload;
      return { ...state, moderators, count, currentPage, isLoading: false }

    case MODERATOR_LIST_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}